// client/src/hooks/useImportProfiles.js

import { useState, useCallback } from 'react';
import importProfileService from '../services/importProfileService';

const useImportProfiles = () => {
  const [profiles, setProfiles] = useState([]);

  const fetchProfiles = useCallback(async () => {
    const data = await importProfileService.getProfiles();
    setProfiles(data);
    return data;
  }, []);

  const createProfile = useCallback((data) => importProfileService.createProfile(data), []);

  const deleteProfile = useCallback((id) => importProfileService.deleteProfile(id), []);

  return { profiles, fetchProfiles, createProfile, deleteProfile };
};

export default useImportProfiles;
